import { trackCtaClick } from "@/utils/trackingScripts";
import type { Page, TextHeader } from "@/generated/sb";

type SectionType = NonNullable<Page["sections"]>[number];

export interface GroupedSection {
  type: "single" | "grouped";
  sections: SectionType[];
  groupType?: string;
  processedSections?: SectionType[];
}

export function processSplitSmallSections(
  sections: SectionType[],
): SectionType[] {
  return sections.map((section) => {
    return {
      ...section,
      buttonTrackingClick: ({ buttonIndex }: { buttonIndex: number }) =>
        trackCtaClick({
          section: section?.head?.[0]?.title?.[0]?.content || "",
          ctaText:
            section?.head?.[0]?.buttonGroup?.[0]?.buttons?.[buttonIndex]
              ?.text || "",
          feature: section?.head?.[0]?.title?.[0]?.content || "",
          config: "splitSmallSection",
        }),
    };
  });
}

export function groupSections(sections: SectionType[]): GroupedSection[] {
  if (!sections || sections.length === 0) return [];

  const result: GroupedSection[] = [];
  let currentGroup: SectionType[] = [];
  let currentGroupType: string | null | undefined = null;
  let lastTextHeader: TextHeader | null = null;

  for (let i = 0; i < sections.length; i++) {
    const section = sections[i];
    const sectionType = section?.component;

    if (sectionType === "textHeader") {
      lastTextHeader = section as TextHeader;
    }

    const sectionWithTextHeader = {
      ...section,
      lastTextHeader: lastTextHeader,
    };

    if (currentGroupType === null || sectionType !== currentGroupType) {
      if (currentGroup.length > 0) {
        const groupedSection: GroupedSection = {
          type: currentGroup.length > 1 ? "grouped" : "single",
          sections: [...currentGroup],
          groupType: currentGroupType || undefined,
        };

        // if (
        //   currentGroupType === "splitSmallSection" &&
        //   shouldGroupSectionType(currentGroupType)
        // ) {
        //   groupedSection.processedSections =
        //     processSplitSmallSections(currentGroup);
        // }

        result.push(groupedSection);
      }

      currentGroup = [sectionWithTextHeader as SectionType];
      currentGroupType = sectionType;
    } else {
      currentGroup.push(sectionWithTextHeader as SectionType);
    }
  }

  if (currentGroup.length > 0) {
    const groupedSection: GroupedSection = {
      type: currentGroup.length > 1 ? "grouped" : "single",
      sections: [...currentGroup],
      groupType: currentGroupType || undefined,
    };

    if (
      currentGroupType === "splitSmallSection" &&
      shouldGroupSectionType(currentGroupType)
    ) {
      groupedSection.processedSections =
        processSplitSmallSections(currentGroup);
    }

    result.push(groupedSection);
  }

  return result;
}

export function shouldGroupSectionType(sectionType: string): boolean {
  const groupableSections = ["splitSmallSection"];
  return groupableSections.includes(sectionType);
}
